export const aboutData = [
  {
    title: 'Teams Involved',
    body: '',
    img: '/assets/images/about/whitewind.png'
  },
  {
    title: 'Mission',
    body: 'Providing unique, professional and tailored solutions in the transport industry in order to successfully meet and support all our customer’s needs.',
    img: ''
  },
  {
    title: 'Vission',
    body: 'We wish to be a leading global service provider in the transportation industry in Africa and beyond, providing both professional and tailored  solutions with a clear customer focus approach based on continuous improvement and commitment.',
    img: ''
  }
]
